import {
  changeFieldValue,
  getTravelPaymentFormValues,
  getQuestion,
  getSection,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, SectionsEnum } from 'app/shared/enums';
import { QuestionInterface } from 'app/shared/interfaces/Question.interface';

const formName = FormsEnum.TravelPaymentForm;

export const consents = {
  fillAllRequiredTravelPaymentConsents() {
    const value = getTravelPaymentFormValues().consent.all.payment;
    const section = getSection(SectionsEnum.PaymentSectionConsents, formName);

    section.questions
      .map((questionKey: FieldsEnum) => getQuestion(questionKey, formName))
      .filter((question: QuestionInterface) => question && question.required)
      .forEach((question: QuestionInterface) =>
        changeFieldValue(question.key, value, formName)
      );
  },
  requiredConsentChange() {
    const allConsentsQuestion = getQuestion(
      FieldsEnum.ButtonConsentsPayment,
      formName
    );

    changeFieldValue(allConsentsQuestion.key, false, formName);
  },
};
